import React, { useEffect, useState } from "react";
import HomeService from "../../../Services/HomeService";

export function WinnersTestimonialsBlue() {
  const [testimonials, setTestimonials] = useState([]);

  const fetchTestimonials = async () => {
    try {
      const res = await HomeService?.getTestimonial();
      if (res?.status) {
        setTestimonials(res?.data || []);
      } else {
        console.log(res);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const staticItems = [
    { heading: "Found our forever home in under three weeks. The visit experience was unreal.", name: "Ananya Sharma", designation: "Homeowner, Gurgaon" },
    { heading: "Most transparent platform I've used. ROI calculations actually held up.", name: "Rohan Mehta", designation: "Investor, Noida" },
    { heading: "The city insights helped me invest in the right locality at the right time.", name: "Priya Iyer", designation: "Investor, Lucknow" },
    { heading: "Loved the curated approach — felt like a concierge, not a portal.", name: "Karan Singh", designation: "Homeowner, Dwarka" },
    { heading: "From shortlist to keys in 6 weeks. Everything just worked.", name: "Meera Joshi", designation: "Homeowner, Faridabad" },
    { heading: "Their reels make property hunting feel like Netflix. In a good way.", name: "Aditya Verma", designation: "Buyer, Indirapuram" },
  ];

  const itemsToDisplay = testimonials.length > 0 ? testimonials : staticItems;
  const loop = [...itemsToDisplay, ...itemsToDisplay];

  return (
    <section className="ws-testi_blue">
      <div className="ws-testi-inner_blue">
        <div className="ws-testi-head_blue">
          <span className="ws-section-eyebrow_blue">Loved by 10,000+ residents</span>
          <h2 className="ws-section-heading_blue">What our community is saying.</h2>
        </div>
      </div>
      <div className="ws-testi-mask_blue">
        <div className="ws-testi-marquee_blue">
          {loop.map((t, i) => (
            <div className="ws-testi-card_blue" key={i}>
              <div className="ws-testi-stars_blue">★★★★★</div>
              <p className="ws-testi-quote_blue">"{t.heading || t.quote}"</p>
              <div className="ws-testi-author_blue">
                <div className="ws-testi-avatar_blue" style={{ overflow: "hidden" }}>
                  {t.image ? (
                    <img 
                      src={t.image} 
                      alt={t.name} 
                      style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%" }} 
                    />
                  ) : (
                    t.name ? t.name.charAt(0) : ""
                  )}
                </div>
                <div>
                  <h4>{t.name}</h4>
                  <span>{t.designation || t.role}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}